import { render, staticRenderFns } from "./ClientActivityDashboard.vue?vue&type=template&id=52c99a17&"
import script from "./ClientActivityDashboard.vue?vue&type=script&lang=js&"
export * from "./ClientActivityDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports